import React from 'react';
import './Advertising.css';

const ADS_METRICS = [
  { label: 'Campañas activas', value: '60+' },
  { label: 'Promedio de impresiones', value: '12K / semana' },
  { label: 'Tiempo de publicación', value: '< 24h' },
];

const ADS_FORMATS = [
  {
    title: 'Destacados en Marketplace',
    description:
      'Posiciona unidades o rutas en la parte superior de los listados relevantes. Ideal para acelerar ocupación o lanzar nuevos lanes.',
  },
  {
    title: 'Banner en Dashboard',
    description:
      'Comparte anuncios contextuales dentro del panel de clientes verificados. Segmentamos por industria, país o tamaño de flota.',
  },
  {
    title: 'Campañas por correo',
    description:
      'Activa envíos curados con oportunidades destacadas y call to actions medibles. Incluye reportes de aperturas y clics.',
  },
];

const ADS_STEPS = [
  'Definimos objetivo y segmento (tipo de cliente, vertical, región).',
  'Seleccionamos formatos, creatividades y duración de la campaña.',
  'Medimos resultados en un dashboard compartido cada semana.',
];

const ADS_BENEFITS = [
  {
    title: 'Segmentación granular',
    description:
      'Usamos datos de operaciones reales, etiquetas de demanda y comportamiento en la plataforma para llegar a quienes buscan tu oferta.',
  },
  {
    title: 'Reportes accionables',
    description:
      'Cada campaña incluye métricas de impresiones, clics, solicitudes generadas y recomendaciones para optimizar el siguiente ciclo.',
  },
  {
    title: 'Equipo dedicado',
    description:
      'Nuestro equipo de Revenue trabaja contigo para alinear mensajes, calendarizar lanzamientos y coordinar seguimiento comercial.',
  },
];

export default function Advertising() {
  return (
    <main className="ads-page">
      <header className="ads-page__hero">
        <div className="ads-page__intro">
          <span className="ads-page__kicker">Programa de publicidad</span>
          <h1 className="ads-page__title">Promociona tus servicios en Flotte</h1>
          <p className="ads-page__subtitle">
            Amplifica la visibilidad de tu inventario y comparte campañas dirigidas a clientes B2B verificados. Diseñamos
            formatos ligeros que conviven con la experiencia del marketplace.
          </p>
        </div>
        <ul className="ads-page__meta">
          {ADS_METRICS.map(item => (
            <li key={item.label}>
              <span className="ads-page__meta-label">{item.label}</span>
              <strong className="ads-page__meta-value">{item.value}</strong>
            </li>
          ))}
        </ul>
      </header>

      <section className="ads-page__section">
        <div className="ads-page__section-head">
          <div>
            <span className="ads-page__eyebrow">Formatos disponibles</span>
            <h2>Elige la combinación ideal</h2>
          </div>
          <p>Los paquetes se ajustan a tu objetivo comercial y puedes rotarlos cada mes según la temporada.</p>
        </div>
        <div className="ads-page__grid">
          {ADS_FORMATS.map(format => (
            <article key={format.title} className="ads-page__card">
              <h3>{format.title}</h3>
              <p>{format.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="ads-page__section ads-page__section--muted">
        <div className="ads-page__section-head">
          <div>
            <span className="ads-page__eyebrow">Cómo funciona</span>
            <h2>Proceso en tres pasos</h2>
          </div>
        </div>
        <ol className="ads-page__steps">
          {ADS_STEPS.map(step => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </section>

      <section className="ads-page__section">
        <div className="ads-page__section-head">
          <div>
            <span className="ads-page__eyebrow">Ventajas</span>
            <h2>Publicidad creada para operadores</h2>
          </div>
        </div>
        <div className="ads-page__grid">
          {ADS_BENEFITS.map(item => (
            <article key={item.title} className="ads-page__card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="ads-page__section ads-page__section--muted">
        <div className="ads-page__cta">
          <div>
            <strong>Agenda una sesión con Revenue</strong>
            <p>
              Escríbenos a <a href="mailto:ads@flotte.mx">ads@flotte.mx</a> y comparte tus objetivos para la siguiente
              campaña.
            </p>
          </div>
          <a className="ads-page__primary" href="mailto:ads@flotte.mx">
            Quiero anunciarme
          </a>
        </div>
      </section>
    </main>
  );
}
